import React from 'react'

import Loader from '../Loader'
import NoDataAvailable from '../NoDataAvailable'
import GameCardFactory from 'factory/GameCardFactory'
import { useSelector } from 'react-redux'
import Slider from 'components/Slider/Slider'
import Icon from 'icons/Icon'
import useFavoriteGames from 'hooks/useFavoriteGames'

function CustomSliderArrow (props) {
  const { className, style, onClick, imgUrl } = props
  return (
    <div
      className={`${className} d-flex`}
      style={{ ...style }}
      onClick={onClick}
    >
      <img src={imgUrl} alt='>' />
    </div>
  )
}

const FavoriteList = () => {
  const { favoriteGamesList, toggleFavorite } = useFavoriteGames()
  const { languageData, selectedLanguageCode } = useSelector((state) => state.language)
  const { favLoading = false } = useSelector((state) => state?.casinoMenu)

  const uiConfig = useSelector((state) => state?.uiConfig?.general)
  const { customCarouselArrows } = uiConfig || {}

  const hasCustomerSliderIcons = Boolean(uiConfig?.customCarouselArrows)

  if (!favoriteGamesList?.count) {
    return (
      <div className='text-center mt-4 mb-3'>
        <NoDataAvailable errorMessage={languageData?.casinoNoFavGamesFound} />
      </div>
    )
  }

  return (
    <>
      {favLoading
        ? (
          <div className='fav-loader'>
            <Loader top='7%' />
          </div>
        )
        : (
          <div className='game-slider-container mt-5'>
            <Slider
              variant={uiConfig?.favoriteListSliderVariant}
              headerIcon={() => <Icon name='sub-category-list-favorite' className='sub-category-list-favorite' width='30' height='30' />}
              headerTitle={languageData?.favourite}
              slides={favoriteGamesList?.rows}
              nextArrow={hasCustomerSliderIcons ? <CustomSliderArrow imgUrl={customCarouselArrows?.nextIcon} /> : null}
              prevArrow={hasCustomerSliderIcons ? <CustomSliderArrow imgUrl={customCarouselArrows?.prevIcon} /> : null}
              sliderCard={({
                index,
                game
              }) => <GameCardFactory
                  game={game}
                  index={index}
                  toggleFavorite={toggleFavorite}
                  selectedLanguageCode={selectedLanguageCode}
                  lobby={false}
                  key={index}
                  favoriteGamesList={favoriteGamesList}
                />}
            />
          </div>
        )}
    </>
  )
}
export default React.memo(FavoriteList)
